import React from "react";
import usePersistedState from "../../hooks/usePersistedState";
import debounce from "../../util/debounce";
import { useStore } from "../../store/store";

function useNotesSelection(submitPressed: boolean, editQuote: boolean) {
  const addToQuote = useStore((state) => state.addToQuote);

  const [showNotes, setShowNotes] = usePersistedState(
    "showNotes",
    false,
    submitPressed,
    editQuote
  );

  const [notesText, setNotesText] = usePersistedState(
    "notesText",
    "",
    submitPressed,
    editQuote
  );

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setNotesText(value);
    debounce(value, addToQuote, "notes", 300);
  };

  const handleClick = () => setShowNotes(!showNotes);

  return {
    handleChange,
    handleClick,
    notesText,
    showNotes,
  };
}

export default useNotesSelection;
